if (!customElements.get("discount-code")) {
  customElements.define(
    "discount-code",
    class DiscountCode extends HTMLElement {
      constructor() {
        super();
        this.copyButton = this.querySelector(".share-button__copy");
        this.closeButton = this.querySelector(".share-button__close");
        this.successMessage = this.querySelector('[id^="DiscountCode"]');
        this.input = this.querySelector(".discount-code");

        this.copyButton.addEventListener(
          "click",
          this.copyToClipboard.bind(this)
        );
      }

      copyToClipboard() {
        if (Shopify.designMode) {
          alert(
            "The Theme Editor restricts this action. Please test it by previewing your store."
          );
        }

        navigator.clipboard.writeText(this.input.dataset.code).then(() => {
          this.classList.add("discount-copied");
          this.closeButton.classList.remove("hidden");
          this.closeButton.focus();

          setTimeout(() => {
            this.closeSuccess();
          }, 3000);
        });
      }

      closeSuccess() {
        this.classList.remove("discount-copied");
        this.closeButton.classList.add("hidden");
      }
    }
  );
}
